import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ApplicationState } from '../../../store';
import { boxesRequest } from '../../../store/modules/boxes/actions';
import { checkStopWinLoss, shouldShowStopModal, markStopModalShown } from '../../../utils/functions';
import StopWinLossModal from '../../../components/StopWinLossModal';
import GuidedTour from '../../../components/GuidedTour';
import Goals from './Boxes/Goals';
import StatsCarousel from './Boxes/StatsCarousel';
import BestAndWorseTrade from './Boxes/BestAndWorseTrade';
import LastTrades from './Boxes/LastTrades';
import MonthlyTracking from './Boxes/MonthlyTracking';
import ProfitAndLoss from './Boxes/ProfitAndLoss';
import WinAndLoss from './Boxes/WinAndLoss';
import DailyCalendar from './Boxes/DailyCalendar';
import PerformanceByTag from './Boxes/PerformanceByTag';

export default function Home() {
  const dispatch = useDispatch();
  const boxesState = useSelector((state: ApplicationState) => state.boxes);
  const userState = useSelector((state: ApplicationState) => state.user);

  const [stopModal, setStopModal] = useState<{
    open: boolean;
    type: 'win' | 'loss';
    stopValue: number;
    todayTotal: number;
  }>({
    open: false,
    type: 'win',
    stopValue: 0,
    todayTotal: 0,
  });

  useEffect(() => {
    if (
      !boxesState.boxes ||
      (Object.entries(boxesState.boxes).length === 0 &&
      boxesState.boxes.constructor === Object) || boxesState.pendingRequest
    ) {
      dispatch(boxesRequest());
    }
  }, []); // eslint-disable-line

  // Check for stop win/loss when data loads
  useEffect(() => {
    if (boxesState.boxes && boxesState.boxes.ProfitAndLoss && boxesState.boxes.ProfitAndLoss.today && boxesState.boxes.ProfitAndLoss.today.total !== undefined) {
      const todayTotal = typeof boxesState.boxes.ProfitAndLoss.today.total === 'string'
        ? parseFloat(boxesState.boxes.ProfitAndLoss.today.total)
        : boxesState.boxes.ProfitAndLoss.today.total;
      const stopWin = userState.user.config.stopWin || 0;
      const stopLoss = userState.user.config.stopLoss || 0;

      const checkResult = checkStopWinLoss(todayTotal, stopWin, stopLoss);

      if (checkResult.type && shouldShowStopModal(checkResult.type)) {
        setStopModal({
          open: true,
          type: checkResult.type,
          stopValue: checkResult.type === 'win' ? stopWin : stopLoss,
          todayTotal,
        });
      }
    }
  }, [boxesState.boxes, userState.user.config]);

  const handleStopModalClose = () => {
    markStopModalShown(stopModal.type);
    setStopModal(prev => ({ ...prev, open: false }));
  };

  return (
    <>
      <StopWinLossModal
        open={stopModal.open}
        onClose={handleStopModalClose}
        type={stopModal.type}
        stopValue={stopModal.stopValue}
        todayTotal={stopModal.todayTotal}
      />
      <GuidedTour />
      <DailyCalendar />
      <ProfitAndLoss />
      <MonthlyTracking />
      <Goals />
      <WinAndLoss />
      <StatsCarousel />
      <LastTrades />
      <PerformanceByTag />
      <BestAndWorseTrade />
    </>
  );
}
